/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ActorDefs from '../../../app/bsky/actor/defs.defs'

const $nsid = 'tools.ozone.team.defs'

type $nsid = typeof $nsid

export { $nsid }

type Member = {
  $type?: 'tools.ozone.team.defs#member'
  did: l.DidString
  role:
    | 'tools.ozone.team.defs#roleAdmin'
    | 'tools.ozone.team.defs#roleModerator'
    | 'tools.ozone.team.defs#roleTriage'
    | 'tools.ozone.team.defs#roleVerifier'
    | l.UnknownString
  profile?: ActorDefs.ProfileViewDetailed
  disabled?: boolean
  createdAt?: l.DatetimeString
  updatedAt?: l.DatetimeString
  lastUpdatedBy?: string
}

export type { Member }

const member = /*#__PURE__*/ l.typedObject<Member>(
  $nsid,
  'member',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    role: /*#__PURE__*/ l.string<{
      knownValues: [
        'tools.ozone.team.defs#roleAdmin',
        'tools.ozone.team.defs#roleModerator',
        'tools.ozone.team.defs#roleTriage',
        'tools.ozone.team.defs#roleVerifier',
      ]
    }>(),
    profile: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ActorDefs.ProfileViewDetailed>(
        (() => ActorDefs.profileViewDetailed) as any,
      ),
    ),
    disabled: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    createdAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    updatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    lastUpdatedBy: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { member }

/** Admin role. Highest level of access, can perform all actions. */
const roleAdmin = /*#__PURE__*/ l.token($nsid, 'roleAdmin')

export { roleAdmin }

/** Admin role. Highest level of access, can perform all actions. */
const RoleAdmin = /*#__PURE__*/ roleAdmin.value

/** Admin role. Highest level of access, can perform all actions. */
type RoleAdmin = typeof RoleAdmin

export { RoleAdmin }

/** Triage role. Mostly intended for monitoring and escalating issues. */
const roleTriage = /*#__PURE__*/ l.token($nsid, 'roleTriage')

export { roleTriage }

/** Triage role. Mostly intended for monitoring and escalating issues. */
const RoleTriage = /*#__PURE__*/ roleTriage.value

/** Triage role. Mostly intended for monitoring and escalating issues. */
type RoleTriage = typeof RoleTriage

export { RoleTriage }

/** Verifier role. Only allowed to issue verifications. */
const roleVerifier = /*#__PURE__*/ l.token($nsid, 'roleVerifier')

export { roleVerifier }

/** Verifier role. Only allowed to issue verifications. */
const RoleVerifier = /*#__PURE__*/ roleVerifier.value

/** Verifier role. Only allowed to issue verifications. */
type RoleVerifier = typeof RoleVerifier

export { RoleVerifier }

/** Moderator role. Can perform most actions. */
const roleModerator = /*#__PURE__*/ l.token($nsid, 'roleModerator')

export { roleModerator }

/** Moderator role. Can perform most actions. */
const RoleModerator = /*#__PURE__*/ roleModerator.value

/** Moderator role. Can perform most actions. */
type RoleModerator = typeof RoleModerator

export { RoleModerator }
